import { render } from "./CampModalCropImage.vue?vue&type=template&id=2c92aae2&scoped=true&ts=true"
import script from "./CampModalCropImage.vue?vue&type=script&lang=ts"
export * from "./CampModalCropImage.vue?vue&type=script&lang=ts"

import "./CampModalCropImage.vue?vue&type=style&index=0&id=2c92aae2&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c92aae2"]])

export default __exports__